module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/12mill-inactive-9417bccce7faf26899ba5fac2010143d.png";